<template>
  <div
    class="vm-key-layout"
    :class="`vm-key-layout--${variant}`"
  >
    <div class="vm-key-layout__left-panel">
      <img
        src="@/assets/layout/vmKey/vm.svg"
        alt="face icons"
      >
      <img
        class="vm-key-layout__text-block"
        src="@/assets/layout/vmKey/textBlock.svg"
        alt="text block"
      >
      <img
        src="@/assets/layout/vmKey/getText.svg"
        alt="face icons"
      >
      <img
        src="@/assets/layout/vmKey/faceIcons.svg"
        alt="face icons"
      >
    </div>
    <div class="vm-key-layout__body">
      <slot />
    </div>
    <div class="vm-key-layout__right-panel">
      <img
        src="@/assets/layout/vmKey/faceIcons.svg"
        alt="face icons"
      >
      <img
        class="vm-key-layout__text-block"
        src="@/assets/layout/vmKey/textBlockRight.svg"
        alt="text block"
      >
      <img
        src="@/assets/layout/vmKey/getText.svg"
        alt="face icons"
      >
      <img
        src="@/assets/layout/vmKey/vm.svg"
        alt="face icons"
      >
    </div>
  </div>
</template>

<script>
export default {
    name: 'VoicemodKeyLayout',
    props: {
        variant: {
            type: String,
            default: '',
        },
    },
};
</script>

<style src="./VoicemodKeyLayout.scss" lang="scss" scoped />
